// import PropTypes from "prop-types"
// import MetaTags from "react-meta-tags"
// import React, { useEffect, useState } from "react"

// import {
//   CardBody,
//   Card,
//   Alert,
//   Container,
//   Nav,
//   NavItem,
//   NavLink,
//   TabContent,
//   TabPane,
//   Modal,
// } from "reactstrap"
// import SweetAlert from "react-bootstrap-sweetalert"
// // import Logimg from "../../assets/images/Loginpage.jpg"
// // Redux
// import { connect } from "react-redux"
// import { withRouter } from "react-router-dom"

// // availity-reactstrap-validation
// import { AvForm, AvField } from "availity-reactstrap-validation"
// import LoginLapImag from "../../assets/images/Login PC.png"
// import LoginMobImag from "../../assets/images/Login PC.png"

// // actions
// import { loginUser, apiError, socialLogin } from "../../store/actions"
// import classnames from "classnames"
// import { isMobile } from "react-device-detect"
// // import firebase from "firebase/app"
// // import "firebase/analytics"
// // import "firebase/messaging"

// const Login = props => {
//   const [ms, setMS] = useState(false)

//   const [ActiveTab, setActiveTab] = useState("Individual")
//   const [customAction, setcustomAction] = useState()
//   const [activeTabContent, setactiveTabContent] = useState("1")
//   const [mssgToken, setmssgToken] = useState("")
//   const [showPassword, setShowPassword] = useState(false)
//   const [toggleMssg, setToggleMssg] = useState("")

//   const handleMssgChange = (event) => {
//     setToggleMssg(event.target.value);
//   };

//   const toggle1 = tab => {
//     if (ActiveTab !== tab) {
//       setActiveTab(tab)
//     }
//   }

//   const togglePassword = () => {
//     setShowPassword(!showPassword)
//   }
//   // handleValidSubmit
//   const handleValidSubmit = (event, values) => {
//     props.loginUser(values, props.history)
//   }
//   const [alert, setAlert] = useState(true)
//   const alertToggle = () => {
//     setAlert(!alert)
//   }
//   const hideAlert = () => {
//     setAlert(false)
//   }
//   const loader = document.querySelector(".loader")

//   useEffect(() => {
//     // const firebaseConfig = {
//   apiKey: "AIzaSyBpR8bsH-BZnZfNTL4weXYf0kpeik5y1nI",
//   authDomain: "api-based-apps.firebaseapp.com",
//   projectId: "api-based-apps",
//   storageBucket: "api-based-apps.firebasestorage.app",
//   messagingSenderId: "310076273692",
//   appId: "1:310076273692:web:cea43a59bba64f0591dbd9",
//   measurementId: "G-BNGQ7W96B1"
// };

//     // // init firebase backend
//     // // initFirebaseBackend(firebaseConfig)

//     // firebase.initializeApp(firebaseConfig)
//     // const analytics = firebase.analytics()
//     // const messaging = firebase.messaging()

//     // // Get registration token. Initially this makes a network call, once retrieved
//     // // subsequent calls to getToken will return from cache.
//     // messaging
//     //   .getToken({
//     //     vapidKey:
//     //       "BJ4DhIruUgaLVh2H8orodqcT0TUQAC7NKuaETeic9b_fnpc33JPb02uVlda_zGaKiwPKVkd4GOlZNCYJ11A_H1g",
//     //   })
//     //   .then(currentToken => {
//     //     if (currentToken) {
//     //       console.log(currentToken)
//     //       setmssgToken(currentToken);
//     //       // Send the token to your server and update the UI if necessary
//     //       // ...
//     //     } else {
//     //       // Show permission request UI
//     //       console.log(
//     //         "No registration token available. Request permission to generate one."
//     //       )
//     //       // ...
//     //     }
//     //   })
//     //   .catch(err => {
//     //     console.log("An error occurred while retrieving token. ", err)
//     //     // ...
//     //   })

//     loader.classList.add("loader--hide")

//     setmssgToken(localStorage.getItem("notificationToken"))
//   }, [])

//   return (
//     <React.Fragment>
//       <MetaTags>
//         <title>Xiaomi - 10 Years of Tomorrow</title>
//       </MetaTags>
//       <Modal
//         size="xl"
//         isOpen={ms}
//         toggle={() => {
//           setMS(!ms)
//         }}
//         centered={true}
//         style={{ width: "auto" }}
//       >
//         <div className="modal-header">
//           <h5 className="modal-title mt-0">Photo Mosaic</h5>
//           <button
//             type="button"
//             onClick={() => {
//               setMS(!ms)
//             }}
//             className="close"
//             data-dismiss="modal"
//             aria-label="Close"
//           >
//             <span aria-hidden="true">&times;</span>
//           </button>
//         </div>
//         <div className="modal-body">
//           <iframe
//             allow="camera; microphone"
//             title="test"
//             className="embed-responsive-item mosaic"
//             src={encodeURI("https://demo-mosaic.herokuapp.com/")}
//           />
//         </div>
//       </Modal>
//       <Container style={{ padding: 0, position: "relative" }} fluid>
//         {isMobile ? (
//           <img loading="lazy"
//             src={LoginMobImag}
//             // src="https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/MI%2FLogin%20Phone.png?alt=media"
//             style={{ position: "absolute", width: "100%" }}
//           ></img>
//         ) : (
//           <img loading="lazy"
//             src={LoginLapImag}
//             // src="https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/MI%2FLogin%20PC.png?alt=media"
//             style={{ position: "absolute", width: "100%" }}
//           ></img>
//         )}
//         <div className="account-pages pt-sm-5">
//           <center className="loginCenter">
//             <Card
//               className="overflow-hidden cardLogin"
//               style={{
//                 // boxShadow: "0px -5rem 2rem 0px rgb(18 38 63 / 3%)",
//                 boxShadow: "none",
//                 background: "transparent",
//               }}
//             >
//               <CardBody className="pt-0" style={{ padding: 0 }}>
//                 <div className="p-2" style={{ color: "#fff" }}>
//                   {/* <div style={{fontSize:"0.7rem",textAlign:"left",color:"black",fontWeight:"bold"}} className="mt-1" >I consent and authorize ABB to the use of my data as part of an ABB initiative to celebrate the Technology Day virtually. Please refer to the ABB privacy policy to know more - <a href="https://new.abb.com/privacy-notice/virtual-events">https://new.abb.com/privacy-notice/virtual-events</a></div> */}
//                   <TabContent
//                     activeTab={activeTabContent}
//                     className="p-3 text-muted"
//                   >
//                     <TabPane tabId="1">
//                       <AvForm
//                         className="form-horizontal"
//                         onValidSubmit={(e, v) => {
//                           handleValidSubmit(e, v)
//                         }}
//                       >
//                         {props.error && typeof props.error === "string" ? (
//                           props.error == "Invalid Email!" ||
//                           props.error ==
//                             "Somethiing went wrong, Please try again!" ||
//                           props.error ==
//                             "User Already registered , Please come back again on the event day to log in." ||
//                           props.error ==
//                             "Oops! Your password is incorrect. Please try again using the correct password." ||
//                           props.error ==
//                             "User Already registered , please login" ||
//                           props.error == "User not Found!" ||
//                           props.error ==
//                             "User not Found! Please Register to login" ||
//                           props.error ==
//                             "Your ID has been registered. Please come back again on the event day to log in." ? (
//                             props.error ==
//                             "Your ID has been registered. Please come back again on the event day to log in." ? (
//                               <SweetAlert
//                                 show={alert}
//                                 success
//                                 // showCancel
//                                 title="Registered Successfully"
//                                 cancelBtnBsStyle="danger"
//                                 // confirmBtnText="Photo Mosaic"
//                                 onConfirm={() => {
//                                   // setMS(true);
//                                   hideAlert(false)
//                                 }}
//                                 // onCancel={hideAlert}
//                                 // onClick={console.log("hi")}
//                                 // timeout={4000}
//                               >
//                                 {props.error}
//                               </SweetAlert>
//                             ) : props.error ==
//                               "User Already registered , Please come back again on the event day to log in." ? (
//                               <SweetAlert
//                                 show={alert}
//                                 success
//                                 // showCancel
//                                 title="Already Registered"
//                                 cancelBtnBsStyle="danger"
//                                 // confirmBtnText="Photo Mosaic"
//                                 onConfirm={() => {
//                                   // setMS(true);
//                                   hideAlert(false)
//                                 }}
//                                 // onCancel={hideAlert}
//                                 // timeout={4000}
//                               >
//                                 {props.error} Please click on Photo Mosaic to
//                                 submit picture for RALLY OF INCLUSION.
//                               </SweetAlert>
//                             ) : (
//                               <SweetAlert
//                                 show={alert}
//                                 // warning
//                                 // title="  Failed!"
//                                 onConfirm={hideAlert}
//                                 // timeout={4000}
//                               >
//                                 {props.error}
//                                 {props.error}a
//                               </SweetAlert>
//                             )
//                           ) : (
//                             <SweetAlert
//                               show={alert}
//                               // warning
//                               // title="Failed!"
//                               onConfirm={hideAlert}
//                               // confirmBtnBsStyle="danger"
//                               confirmBtnCssClass="sweetAlertBtn"
//                               // timeout={4000}
//                             >
//                               {props.error}
//                             </SweetAlert>
//                           )
//                         ) : null}
//                         {/* <div className="newlog">
//                       Login
//                     </div> */}
//                         {/* <div className="mb-1">
//                           <AvField
//                             type="select"
//                             name="type"
//                             defaultValue=""
//                             required
//                             onChange={handleMssgChange}
//                           >
//                             <option
//                               value=""
//                               disabled
//                               style={{ color: "#495057" }}
//                             >
//                               Choose Partners/Employee *
//                             </option>
//                             <option value="Partner">Partner</option>
//                             <option value="Employee">Employee</option>
//                           </AvField>
//                         </div> */}

//                         <div className="mb-1">
//                           <AvField
//                             name="Firstname"
//                             // style={{fontSize:"inherit"}}
//                             value=""
//                             className="form-control  "
//                             placeholder="Name *"
//                             type="text"
//                             required
//                           />
//                         </div>

//                         <div className="mb-1">
//                           <AvField
//                             name="Email"
//                             // style={{fontSize:"inherit"}}
//                             value=""
//                             className="form-control  "
//                             placeholder="Email *"
//                             type="Email"
//                             required
//                           />
//                         </div>
//                         <div className="mb-1">
//                           <AvField
//                             name="EmployeeID"
//                             // style={{fontSize:"inherit"}}
//                             value=""
//                             className="form-control  "
//                             placeholder="Employee Code *"
//                             type="text"
//                             required
//                           />
//                         </div>

//                         {/* <div className="mb-1">
//                           <AvField
//                             name="otp"
//                           // style={{fontSize:"inherit"}}
//                             value=""
//                             className="form-control  "
//                             placeholder=" OTP shared on Mail*"
//                             type="number"
//                             // required
//                           />
//                         </div> */}
//                         <div className="mb-1">
//                           <AvField
//                             name="customaction"
//                             value={customAction}
//                             className="form-control  "
//                             placeholder="action *"
//                             type="text"
//                             // required
//                             disabled
//                             hidden
//                           />
//                         </div>
//                         {/* <div className="mb-1">
//                           <AvField
//                             name="Password"
//                             value=""
//                             className="form-control  "
//                             placeholder="Password *"
//                             type="password"
//                             required
//                           />
//                         </div> */}
//                         {/* <div className="mb-2">
//                         <AvCheckboxGroup inline name="one" label=" " required>
//                         <AvCheckbox label="By ticking this box you are agreeing to receive marketing communications from Lenovo and are providing express consent to receive these messages. This includes both email and phone communications. You may unsubscribe at any time by using the link provided in each email or contacting Lenovo at privacy@lenovo.com" value="Bulbasaur" />
//                         </AvCheckboxGroup>
//                         <AvCheckboxGroup inline name="two" label=" " required>
//                         <AvCheckbox label="You are providing consent that Lenovo may process your data in the manner indicated above and described in our Privacy Policy." value="Bulbasaur" />
//                         </AvCheckboxGroup>
//                         </div> */}

//                         <div
//                           className="mt-3 d-flex justify-content-evenly"
//                           style={{ textAlign: "center" }}
//                         >
//                           <button
//                             // onClick={()=>{setcustomAction("Login")}}
//                             style={{
//                               backgroundColor: "rgb(255,255,254)",
//                               color: "white",
//                               borderColor: "white",
//                               // width: "100%",
//                               fontWeight: "bold",
//                               marginRight: "5%",
//                             }}
//                             className="btn btn-primary btn-block "
//                             type="submit"
//                           >
//                             Login
//                           </button>
//                           {/* <button
//                            onClick={()=>{setcustomAction("verify")}}
//                             style={{
//                               backgroundColor: "#24468B",
//                               color: "white",
//                               borderColor: "white",
//                               // width: "100%",
//                               fontWeight:"bold"
//                             }}
//                             className="btn btn-primary btn-block "
//                             type="submit"
//                           >
//                            Verify OTP
//                           </button> */}
//                         </div>

//                         {/* <div style={{ fontSize: "0.7rem", textAlign: "left", color: "black", fontWeight: "bold" }} className="mt-1">Kindly Register for before login. </div> */}
//                       </AvForm>
//                     </TabPane>
//                     {/* <div style={{color:"white",fontSize:"0.6rem",marginTop:"1%"}} > *Please use your official email Id to Login</div> */}
//                   </TabContent>
//                   {toggleMssg==="Employee" ? "Please enter your name and employee ID.":"Please enter your store name and partner ID."}
//                   {/* *Please use your registered email ID to login */}
//                 </div>
//               </CardBody>
//             </Card>
//           </center>
//         </div>
//       </Container>
//     </React.Fragment>
//   )
// }

// const mapStateToProps = state => {
//   const { error } = state.Login
//   return { error }
// }

// export default withRouter(
//   connect(mapStateToProps, { loginUser, apiError, socialLogin })(Login)
// )

// Login.propTypes = {
//   error: PropTypes.any,
//   history: PropTypes.object,
//   loginUser: PropTypes.func,
//   socialLogin: PropTypes.func,
// }

// -------------------------------------
// Login.jsx  — Route: /login (holding page with Login + Register)
// All original logic preserved. Theme unified with Register.jsx (/home).

import PropTypes from "prop-types"
import MetaTags from "react-meta-tags"
import React, { useEffect, useRef, useState } from "react"
import {
  CardBody,
  Card,
  Container,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Modal,
} from "reactstrap"
import SweetAlert from "react-bootstrap-sweetalert"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { AvForm, AvField } from "availity-reactstrap-validation"
import classnames from "classnames"
import { isMobile } from "react-device-detect"

import { loginUser, apiError, socialLogin } from "../../store/actions"
import CustomPopup from "pages/customPopup"
import "../hexagon.css"

import Logo from "../../assets/images/companylogo1.png"
import NameLogo from "../../assets/images/companynamelogo1.png"

// ─── Firebase background images ───────────────────────────────────────────────
const BgLandscape =
  "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/Mindex%20Clinical%20Spectrum%2FLogin%20Page%20-%201920x1080.png?alt=media&token=fd0c3d08-038d-49b4-afc8-859fb6f1fa43"
const BgPortrait =
  "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/Mindex%20Clinical%20Spectrum%2FLogin%20Page%20-%201080x1920.png?alt=media&token=50a6fb45-886b-4853-a24e-565472642f4a"

// ─── State → Cities data ──────────────────────────────────────────────────────
const STATE_CITIES = {
  "Andhra Pradesh": [
    "Visakhapatnam",
    "Vijayawada",
    "Guntur",
    "Nellore",
    "Kurnool",
  ],
  "Arunachal Pradesh": ["Itanagar", "Naharlagun", "Pasighat"],
  Assam: ["Guwahati", "Silchar", "Dibrugarh", "Jorhat", "Nagaon"],
  Bihar: ["Patna", "Gaya", "Bhagalpur", "Muzaffarpur", "Darbhanga"],
  Chhattisgarh: ["Raipur", "Bhilai", "Bilaspur", "Korba", "Durg"],
  Goa: ["Panaji", "Margao", "Vasco da Gama", "Mapusa"],
  Gujarat: ["Ahmedabad", "Surat", "Vadodara", "Rajkot", "Bhavnagar"],
  Haryana: ["Gurugram", "Faridabad", "Panipat", "Ambala", "Hisar"],
  "Himachal Pradesh": ["Shimla", "Manali", "Dharamshala", "Solan", "Mandi"],
  Jharkhand: ["Ranchi", "Jamshedpur", "Dhanbad", "Bokaro", "Deoghar"],
  Karnataka: ["Bengaluru", "Mysuru", "Mangaluru", "Hubballi", "Belagavi"],
  Kerala: ["Thiruvananthapuram", "Kochi", "Kozhikode", "Thrissur", "Kollam"],
  "Madhya Pradesh": ["Bhopal", "Indore", "Jabalpur", "Gwalior", "Ujjain"],
  Maharashtra: ["Mumbai", "Pune", "Nagpur", "Nashik", "Aurangabad", "Thane"],
  Manipur: ["Imphal", "Thoubal", "Bishnupur"],
  Meghalaya: ["Shillong", "Tura", "Jowai"],
  Mizoram: ["Aizawl", "Lunglei", "Saiha"],
  Nagaland: ["Kohima", "Dimapur", "Mokokchung"],
  Odisha: ["Bhubaneswar", "Cuttack", "Rourkela", "Berhampur", "Sambalpur"],
  Punjab: ["Ludhiana", "Amritsar", "Jalandhar", "Patiala", "Bathinda"],
  Rajasthan: ["Jaipur", "Jodhpur", "Udaipur", "Kota", "Ajmer"],
  Sikkim: ["Gangtok", "Namchi", "Pelling"],
  "Tamil Nadu": [
    "Chennai",
    "Coimbatore",
    "Madurai",
    "Tiruchirappalli",
    "Salem",
  ],
  Telangana: ["Hyderabad", "Warangal", "Nizamabad", "Karimnagar", "Ramagundam"],
  Tripura: ["Agartala", "Udaipur", "Dharmanagar"],
  "Uttar Pradesh": [
    "Lucknow",
    "Kanpur",
    "Varanasi",
    "Agra",
    "Meerut",
    "Prayagraj",
  ],
  Uttarakhand: ["Dehradun", "Haridwar", "Roorkee", "Haldwani", "Nainital"],
  "West Bengal": ["Kolkata", "Howrah", "Durgapur", "Asansol", "Siliguri"],
  Delhi: [
    "New Delhi",
    "North Delhi",
    "South Delhi",
    "East Delhi",
    "West Delhi",
  ],
  Chandigarh: ["Chandigarh"],
  "Jammu & Kashmir": ["Srinagar", "Jammu", "Anantnag", "Sopore"],
  Ladakh: ["Leh", "Kargil"],
  Puducherry: ["Puducherry", "Karaikal", "Mahe", "Yanam"],
}

// ─── Particles (stable, outside component) ────────────────────────────────────
const PARTICLES = Array.from({ length: 22 }, (_, i) => ({
  id: i,
  size: Math.random() * 6 + 3,
  left: Math.random() * 100,
  delay: Math.random() * 20,
  dur: Math.random() * 13 + 11,
}))

function Particles() {
  return (
    <div className="lx-particles">
      {PARTICLES.map(p => (
        <div
          key={p.id}
          className="lx-particle"
          style={{
            width: p.size,
            height: p.size,
            left: `${p.left}%`,
            animationDelay: `${p.delay}s`,
            animationDuration: `${p.dur}s`,
          }}
        />
      ))}
    </div>
  )
}

// ─── T&C Modal ────────────────────────────────────────────────────────────────
function TnCModal({ onClose }) {
  return (
    <div className="lx-po lx-tnc-overlay" onClick={onClose}>
      <div className="lx-tnc-box" onClick={e => e.stopPropagation()}>
        <div className="lx-tnc-header">
          <span className="lx-tnc-title">Terms &amp; Conditions</span>
          <button className="lx-tnc-close" onClick={onClose} aria-label="Close">
            ✕
          </button>
        </div>
        <div className="lx-tnc-body">
          <p>
            I hereby voluntarily provide my consent to <strong>Danone</strong>{" "}
            and its authorized third party partners:
          </p>
          <ol>
            <li>
              To collect, use, process and store my sensitive personal data and
              information in accordance with applicable law.
            </li>
            <li>
              To have access to my sensitive personal data and information in
              accordance with applicable law.
            </li>
          </ol>
          <p>
            I understand and I consent to Danone and its authorized third party
            partners sending me updates and important information from time to
            time by way of <strong>WhatsApp, SMS and/or email</strong>.
          </p>
          <p className="lx-tnc-withdraw">
            I understand that I can withdraw my consent at any time by
            contacting Danone.
          </p>
        </div>
        <div className="lx-tnc-footer">
          <button className="lx-tnc-btn" onClick={onClose}>
            I Understand
          </button>
        </div>
      </div>
    </div>
  )
}

// ─── Themed Popup ─────────────────────────────────────────────────────────────
function ThemedPopup({ type, title, message, dateNote, onClose }) {
  return (
    <div className="lx-po" onClick={onClose}>
      <div className={`lx-pb ${type}`} onClick={e => e.stopPropagation()}>
        <div className={`lx-piw ${type}`}>{type === "success" ? "✓" : "✕"}</div>
        <div className="lx-pt">{title}</div>
        <div className="lx-pm">{message}</div>
        {/* {dateNote && <div className="lx-pm-date">📅 {dateNote}</div>} */}
        <button className={`lx-pc ${type}`} onClick={onClose}>
          {type === "success" ? "Got it!" : "Try Again"}
        </button>
      </div>
    </div>
  )
}

// ─── Inline styles ────────────────────────────────────────────────────────────
const css = `
@font-face { font-family:'Acumin'; src:url('/assets/fonts/AcuminVariableConcept.otf') format('opentype'); font-weight:100 900; }
@font-face { font-family:'Inter'; src:url('/assets/fonts/Inter_18pt-Thin.ttf') format('truetype'); font-weight:100; }
@font-face { font-family:'Inter'; src:url('/assets/fonts/Inter_18pt-Light.ttf') format('truetype'); font-weight:300; }
@font-face { font-family:'Inter'; src:url('/assets/fonts/Inter_18pt-Regular.ttf') format('truetype'); font-weight:400; }
@font-face { font-family:'Inter'; src:url('/assets/fonts/Inter_18pt-Bold.ttf') format('truetype'); font-weight:700; }
@font-face { font-family:'MyriadPro'; src:url('/assets/fonts/MyriadPro-Regular.otf') format('opentype'); font-weight:400; }

:root {
  --lx-navy:   #2D3991;
  --lx-mid:    #3255CC;
  --lx-sky:    #4fc1b0;
  --lx-text:   #1A1F4B;
  --lx-muted:  #6B7AAD;
  --lx-error:  #E8395A;
  --lx-fd:     'Acumin','Inter',sans-serif;
  --lx-fb:     'Inter','MyriadPro',sans-serif;
}

/* ── Full-page BG — static image, landscape by default, portrait on mobile ── */
.lx-scene {
  position: fixed; inset: 0; z-index: 0; overflow: hidden;
  background-image: url(${BgLandscape});
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}
@media (max-width: 920px) {
  .lx-scene { background-image: url(${BgPortrait}); }
}

/* ── Commented-out animated BG elements ──
.lx-blob { ... } .lx-b1 { ... } ... .lx-grid { ... } .lx-grain { ... }
── end commented-out BG ── */

.lx-particles { position:absolute;inset:0;pointer-events:none; }
.lx-particle { position:absolute;border-radius:50%;background:var(--lx-sky);animation:lxpf linear infinite;opacity:0; }
@keyframes lxpf{0%{transform:translateY(100vh) scale(0);opacity:0}10%{opacity:.55}90%{opacity:.25}100%{transform:translateY(-10vh) scale(1.6);opacity:0}}

/* ── Rings — boosted opacity, don't fully fade away ── */
.lx-rings { position:absolute;right:7%;top:50%;transform:translateY(-50%);pointer-events:none; }
.lx-ring { position:absolute;border-radius:50%;top:50%;left:50%;transform:translate(-50%,-50%);animation:lxrp ease-out infinite; }
.lx-r1{width:140px;height:140px;border:1.5px solid rgba(137,207,240,.85);animation-duration:3.2s;animation-delay:0s}
.lx-r2{width:240px;height:240px;border:1.5px solid rgba(50,85,204,.60);animation-duration:3.2s;animation-delay:.7s}
.lx-r3{width:340px;height:340px;border:1px solid rgba(45,57,145,.42);animation-duration:3.2s;animation-delay:1.4s}
.lx-r4{width:440px;height:440px;border:1px solid rgba(137,207,240,.30);animation-duration:3.2s;animation-delay:2.1s}
.lx-r5{width:540px;height:540px;border:1px solid rgba(50,85,204,.20);animation-duration:3.2s;animation-delay:2.8s}
@keyframes lxrp{0%{transform:translate(-50%,-50%) scale(.3);opacity:1}60%{opacity:.75}100%{transform:translate(-50%,-50%) scale(1.7);opacity:.18}}

/* ── Page layout ── */
.lx-wrap { position:relative;z-index:1;min-height:100vh;display:grid;grid-template-columns:1fr 1fr;align-items:stretch; }

/* ── Left panel ── */
.lx-left { display:flex;flex-direction:column;justify-content:center;align-items:center;padding:48px 24px 48px 110px;position:relative; }
/* deco-logo — more visible (opacity .18 vs original .055) */
.lx-deco { position:absolute;right:-20%;opacity:.18;pointer-events:none;animation:lxds 50s linear infinite; }
.lx-deco img { width:250px; }
@keyframes lxds{from{transform:rotate(0)}to{transform:rotate(360deg)}}
/* a1/a2 — centered */
.lx-a1{opacity:0;animation:lxsu .85s .15s cubic-bezier(.22,1,.36,1) forwards;display:flex;justify-content:center;width:100%}
.lx-a2{opacity:0;animation:lxsu .85s .35s cubic-bezier(.22,1,.36,1) forwards;display:flex;justify-content:center;width:100%}
@keyframes lxsu{from{opacity:0;transform:translateY(30px)}to{opacity:1;transform:translateY(0)}}
/* logo — bigger (240px vs original 180px) */
.lx-logo { height:180px;object-fit:contain; }
.lx-date-pill { margin-top:32px;display:inline-flex;align-items:center;gap:10px;position:relative; }
.lx-date-text { font-family:var(--lx-fd);font-size:1.1rem;font-weight:600;letter-spacing:.04em;background:linear-gradient(110deg,var(--lx-navy) 0%,var(--lx-mid) 50%,var(--lx-sky) 100%);background-size:220% 100%;-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;animation:lxgs 4s ease infinite alternate; }
@keyframes lxgs{0%{background-position:0% 50%}100%{background-position:100% 50%}}
.lx-date-pill::after { content:'';position:absolute;bottom:-6px;left:0;right:0;height:2px;background:linear-gradient(90deg,var(--lx-sky),var(--lx-mid),var(--lx-navy),var(--lx-mid),var(--lx-sky));background-size:200% 100%;border-radius:2px;animation:lxtb 2.5s linear infinite;box-shadow:0 0 8px rgba(50,85,204,.45); }
@keyframes lxtb{0%{background-position:0%}100%{background-position:200%}}
.lx-dot { width:8px;height:8px;border-radius:50%;flex-shrink:0;background:var(--lx-mid);animation:lxdp 1.8s ease-in-out infinite; }
@keyframes lxdp{0%{box-shadow:0 0 0 0 rgba(50,85,204,.5)}60%{box-shadow:0 0 0 7px rgba(50,85,204,0)}100%{box-shadow:0 0 0 0 rgba(50,85,204,0)}}

/* ── Right panel / card ── */
.lx-right { display:flex;align-items:center;justify-content:center;padding:28px 32px 28px 0; }
.lx-card { width:100%;max-width:460px;background:rgba(255,255,255,.78);backdrop-filter:blur(32px) saturate(1.5);border:1px solid rgba(137,207,240,.45);border-radius:28px;padding:32px 34px 28px;box-shadow:0 2px 1px rgba(255,255,255,.95) inset,0 28px 90px rgba(45,57,145,.13),0 4px 18px rgba(137,207,240,.22);opacity:0;animation:lxci .9s .45s cubic-bezier(.22,1,.36,1) forwards;position:relative;overflow:hidden;font-family:var(--lx-fb); }
.lx-card::before { content:'';position:absolute;top:0;left:-100%;width:50%;height:100%;background:linear-gradient(90deg,transparent,rgba(255,255,255,.38),transparent);animation:lxsw 3s 1.3s ease forwards;pointer-events:none; }
@keyframes lxsw{0%{left:-100%}100%{left:210%}}
.lx-card::after { content:'';position:absolute;top:0;left:0;right:0;height:3px;background:linear-gradient(90deg,var(--lx-sky),var(--lx-mid),var(--lx-navy),var(--lx-mid),var(--lx-sky));background-size:200% 100%;animation:lxtb 2.8s linear infinite; }
@keyframes lxci{from{opacity:0;transform:translateX(44px) scale(.96)}to{opacity:1;transform:translateX(0) scale(1)}}

.lx-ct { font-family:var(--lx-fd);font-size:1.4rem;font-weight:700;color:var(--lx-text);text-align:center;margin-bottom:3px;letter-spacing:-.01em; }
.lx-cs { font-size:.82rem;color:var(--lx-muted);font-weight:300;text-align:center;margin-bottom:20px; }

/* ── Auth mode selector buttons ── */
.lx-auth-btn { width:100%;padding:14px;border:none;border-radius:50px;cursor:pointer;font-family:var(--lx-fd);font-size:1rem;font-weight:700;letter-spacing:.03em;color:white;background:linear-gradient(to right,var(--lx-navy) 0%,var(--lx-sky) 55%);background-size:200% 100%;position:relative;overflow:hidden;transition:transform .2s,box-shadow .2s,background-position .45s;box-shadow:0 6px 26px rgba(50,85,204,.42);margin-bottom:0; }
.lx-auth-btn:hover { transform:translateY(-3px) scale(1.01);box-shadow:0 14px 40px rgba(50,85,204,.52);background-position:100% 0%; }
.lx-auth-btn:active { transform:translateY(-1px) scale(.99); }
.lx-auth-btn-outline {
  width: 100%;
  padding: 13px;
  border: 2px solid transparent;
  border-radius: 50px;
  cursor: pointer;
  font-family: var(--lx-fd);
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: .03em;
  color: var(--lx-sky);
  background:
    linear-gradient(white, white) padding-box,
    linear-gradient(to right, var(--lx-navy) 0%, var(--lx-sky) 55%) border-box;
  transition: transform .2s, box-shadow .2s, color .2s;
  box-shadow: 0 4px 16px rgba(50, 85, 204, .12);
}

.lx-auth-btn-outline:hover {
  background:
    linear-gradient(to right, var(--lx-navy) 0%, var(--lx-sky) 55%) padding-box,
    linear-gradient(to right, var(--lx-navy) 0%, var(--lx-sky) 55%) border-box;
  color: white;
  transform: translateY(-3px);
  box-shadow: 0 10px 30px rgba(50, 85, 204, .4);
}
.lx-divider { display:flex;align-items:center;gap:10px;margin:14px 0;color:var(--lx-muted);font-size:.78rem; }
.lx-divider::before,.lx-divider::after { content:'';flex:1;height:1px;background:rgba(45,57,145,.1); }

/* ── Back button ── */
.lx-back { background:none;border:none;cursor:pointer;font-family:var(--lx-fb);font-size:.82rem;color:var(--lx-muted);padding:0 0 12px;display:inline-flex;align-items:center;gap:4px;transition:color .2s; }
.lx-back:hover { color:var(--lx-navy); }

/* ── Section title ── */
.lx-section-title { font-family:var(--lx-fd);font-size:1.1rem;font-weight:700;color:var(--lx-text);text-align:center;margin-bottom:18px; }

/* ── Form fields ── */
.lx-fg { margin-bottom:12px;position:relative; }
.lx-fl { display:block;font-size:.7rem;font-weight:500;color:var(--lx-muted);letter-spacing:.1em;text-transform:uppercase;margin-bottom:5px;font-family:var(--lx-fb); }
.lx-fg input,.lx-fg select,.lx-fg .form-control { width:100%!important;padding:11px 14px!important;border:1.5px solid rgba(45,57,145,.13)!important;border-radius:13px!important;background:rgba(240,244,255,.55)!important;color:var(--lx-text)!important;font-family:var(--lx-fb)!important;font-size:.9rem!important;outline:none!important;height:auto!important;transition:border-color .25s,background .25s,box-shadow .25s,transform .18s!important;box-shadow:none!important;appearance:none!important; }
.lx-fg input:focus,.lx-fg select:focus,.lx-fg .form-control:focus { border-color:var(--lx-mid)!important;background:rgba(255,255,255,.97)!important;box-shadow:0 0 0 4px rgba(50,85,204,.09),0 2px 14px rgba(50,85,204,.07)!important;transform:translateY(-1px)!important; }
.lx-fg input::placeholder,.lx-fg .form-control::placeholder { color:#B4BCDA!important; }
.lx-fg select:disabled { opacity:.5;cursor:not-allowed; }
.lx-fg .invalid-feedback { font-size:.72rem;color:var(--lx-error);margin-top:3px;display:block; }
.lx-fg.has-error input,.lx-fg.has-error select { border-color:var(--lx-error)!important;background:rgba(232,57,90,.04)!important; }
.lx-card .mb-1 input,.lx-card .mb-1 select,.lx-card .mb-1 .form-control,.lx-card .mb-3 input,.lx-card .mb-3 select { padding:11px 14px!important;border:1.5px solid rgba(45,57,145,.13)!important;border-radius:13px!important;background:rgba(240,244,255,.55)!important;color:var(--lx-text)!important;font-family:var(--lx-fb)!important;font-size:.9rem!important;outline:none!important;height:auto!important;transition:border-color .25s,background .25s,box-shadow .25s,transform .18s!important;box-shadow:none!important; }
.lx-card .mb-1 input:focus,.lx-card .mb-1 select:focus,.lx-card .mb-1 .form-control:focus,.lx-card .mb-3 input:focus { border-color:var(--lx-mid)!important;background:rgba(255,255,255,.97)!important;box-shadow:0 0 0 4px rgba(50,85,204,.09)!important;transform:translateY(-1px)!important; }

.lx-sel { position:relative; }
.lx-sel::after { content:'▾';position:absolute;right:12px;top:50%;transform:translateY(-50%);font-size:.75rem;color:var(--lx-muted);pointer-events:none; }
.lx-sel select { padding-right:32px!important;cursor:pointer;width:100%; }
.lx-phone-row { display:grid;grid-template-columns:52px 1fr;gap:8px; }
.lx-phone-pre { display:flex;align-items:center;justify-content:center;background:rgba(50,85,204,.08);border:1.5px solid rgba(45,57,145,.13);border-radius:13px;font-size:.88rem;font-weight:600;color:var(--lx-navy);letter-spacing:.02em;font-family:var(--lx-fb); }
.lx-other-city { overflow:hidden;max-height:0;opacity:0;transform:translateY(-6px);transition:max-height .3s ease,opacity .3s ease,transform .3s ease;margin-top:0; }
.lx-other-city.visible { max-height:60px;opacity:1;transform:translateY(0);margin-top:8px; }
.lx-other-city input { width:100%;padding:11px 14px;border:1.5px solid rgba(45,57,145,.13);border-radius:13px;background:rgba(240,244,255,.55);color:var(--lx-text);font-family:var(--lx-fb);font-size:.9rem;outline:none;transition:border-color .25s,background .25s,box-shadow .25s;appearance:none; }
.lx-other-city input:focus { border-color:var(--lx-mid);background:rgba(255,255,255,.97);box-shadow:0 0 0 4px rgba(50,85,204,.09); }
.lx-other-city input::placeholder { color:#B4BCDA; }

/* ── T&C checkbox ── */
.lx-tnc-row { display:flex;align-items:flex-start;gap:10px;margin:14px 0 10px;padding:12px 14px;border-radius:13px;background:rgba(50,85,204,.05);border:1.5px solid rgba(50,85,204,.1);transition:border-color .25s,background .25s; }
.lx-tnc-row.checked { background:rgba(50,85,204,.08);border-color:rgba(50,85,204,.25); }
.lx-tnc-chk { position:relative;flex-shrink:0;width:18px;height:18px;margin-top:1px; }
.lx-tnc-chk input[type="checkbox"] { position:absolute;opacity:0;width:18px;height:18px;margin:0;cursor:pointer;z-index:1; }
.lx-tnc-box { width:18px;height:18px;border:2px solid rgba(50,85,204,.35);border-radius:5px;background:white;display:flex;align-items:center;justify-content:center;transition:background .2s,border-color .2s,transform .15s;pointer-events:none; }
.lx-tnc-chk input:checked ~ .lx-tnc-box { background:linear-gradient(135deg,var(--lx-navy),var(--lx-mid));border-color:var(--lx-mid);transform:scale(1.08); }
.lx-tnc-box svg { opacity:0;transform:scale(0);transition:opacity .18s,transform .18s; }
.lx-tnc-chk input:checked ~ .lx-tnc-box svg { opacity:1;transform:scale(1); }
.lx-tnc-lbl { font-size:.78rem;color:var(--lx-muted);line-height:1.55;font-family:var(--lx-fb); }
.lx-tnc-link { color:var(--lx-mid);font-weight:600;cursor:pointer;text-decoration:underline;text-underline-offset:2px;background:none;border:none;padding:0;font-family:var(--lx-fb);font-size:inherit;transition:color .15s; }
.lx-tnc-link:hover { color:var(--lx-navy); }

/* ── Submit button ── */
.lx-sbtn { width:100%;padding:14px;margin-top:6px;border:none;border-radius:50PX;cursor:pointer;font-family:var(--lx-fd);font-size:.98rem;font-weight:700;letter-spacing:.04em;color:white;background:linear-gradient(to right,var(--lx-navy) 0%,var(--lx-sky) 55%);background-size:200% 100%;position:relative;overflow:hidden;transition:transform .2s,box-shadow .2s,background-position .45s,opacity .2s;box-shadow:0 6px 26px rgba(50,85,204,.42); }
.lx-sbtn:hover:not(:disabled) { transform:translateY(-3px) scale(1.01);box-shadow:0 14px 40px rgba(50,85,204,.52);background-position:100% 0%; }
.lx-sbtn:active:not(:disabled) { transform:translateY(-1px) scale(.99); }
.lx-sbtn:disabled { opacity:.38;cursor:not-allowed;box-shadow:none;transform:none; }
.lx-sbtn::before { content:'';position:absolute;top:0;left:-80%;width:50%;height:100%;background:linear-gradient(90deg,transparent,rgba(255,255,255,.22),transparent);transform:skewX(-15deg); }
.lx-sbtn:hover:not(:disabled)::before { animation:lxbsh .5s ease forwards; }
@keyframes lxbsh{0%{left:-80%}100%{left:155%}}
.lx-arr { display:inline-block;margin-left:8px;animation:lxab 1.6s ease-in-out infinite; }
@keyframes lxab{0%,100%{transform:translateX(0)}50%{transform:translateX(5px)}}
.lx-spin { display:inline-block;width:14px;height:14px;border:2px solid rgba(255,255,255,.4);border-top-color:white;border-radius:50%;animation:lxspn .7s linear infinite;margin-left:10px;vertical-align:middle; }
@keyframes lxspn{to{transform:rotate(360deg)}}

/* ── Popups ── */
.lx-po { position:fixed;inset:0;z-index:9999;background:rgba(8,12,44,.52);backdrop-filter:blur(12px);display:flex;align-items:center;justify-content:center;animation:lxfoi .22s ease; }
@keyframes lxfoi{from{opacity:0}to{opacity:1}}
.lx-pb { background:white;border-radius:28px;padding:44px 38px;max-width:420px;width:88%;text-align:center;box-shadow:0 36px 110px rgba(45,57,145,.24);animation:lxpbi .42s cubic-bezier(.22,1,.36,1);position:relative;overflow:hidden; }
.lx-pb::before { content:'';position:absolute;top:0;left:0;right:0;height:4px; }
.lx-pb.success::before { background:linear-gradient(90deg,var(--lx-sky),var(--lx-mid),var(--lx-navy)); }
.lx-pb.error::before   { background:linear-gradient(90deg,var(--lx-error),#FF6B8A); }
@keyframes lxpbi{from{opacity:0;transform:scale(.8) translateY(28px)}to{opacity:1;transform:scale(1) translateY(0)}}
.lx-piw { width:72px;height:72px;border-radius:50%;margin:0 auto 18px;display:flex;align-items:center;justify-content:center;font-size:30px;position:relative;animation:lxib .55s .28s cubic-bezier(.22,1,.36,1) both; }
@keyframes lxib{0%{transform:scale(0)}65%{transform:scale(1.18)}100%{transform:scale(1)}}
.lx-piw::before,.lx-piw::after { content:'';position:absolute;inset:0;border-radius:50%;animation:lxir 2.2s ease-out infinite; }
.lx-piw::after { animation-delay:.8s; }
.lx-piw.success { background:rgba(50,85,204,.1); }
.lx-piw.success::before,.lx-piw.success::after { border:2px solid rgba(50,85,204,.25); }
.lx-piw.error   { background:rgba(232,57,90,.1); }
.lx-piw.error::before,.lx-piw.error::after { border:2px solid rgba(232,57,90,.3); }
@keyframes lxir{0%{transform:scale(1);opacity:.8}100%{transform:scale(2.4);opacity:0}}
.lx-pt { font-family:var(--lx-fd);font-size:1.32rem;font-weight:700;color:var(--lx-text);margin-bottom:8px; }
.lx-pm { font-size:.88rem;color:var(--lx-muted);line-height:1.65;margin-bottom:10px;font-family:var(--lx-fb); }
.lx-pm-date { font-family:var(--lx-fd);font-size:1rem;font-weight:700;background:linear-gradient(110deg,var(--lx-navy) 0%,var(--lx-mid) 50%,var(--lx-sky) 100%);background-size:220% 100%;-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;animation:lxgs 4s ease infinite alternate;margin-bottom:22px;display:inline-block; }
.lx-pc { padding:12px 36px;border:none;border-radius:50px;cursor:pointer;font-family:var(--lx-fd);font-size:.93rem;font-weight:700;color:white;transition:transform .2s,box-shadow .2s; }
.lx-pc.success { background:linear-gradient(to right,var(--lx-navy) 0%,var(--lx-sky) 55%);box-shadow:0 6px 24px rgba(50,85,204,.42); }
.lx-pc.error   { background:linear-gradient(to right,var(--lx-navy) 0%,var(--lx-sky) 55%);box-shadow:0 6px 20px rgba(50,85,204,.38); }
.lx-pc:hover   { transform:translateY(-2px); }

/* ── T&C modal ── */
.lx-tnc-overlay { align-items:flex-end; }
@media(min-width:481px){ .lx-tnc-overlay { align-items:center; } }
.lx-tnc-box { background:white;border-radius:24px;width:88%;max-width:500px;max-height:82vh;display:flex;flex-direction:column;box-shadow:0 32px 100px rgba(45,57,145,.22);animation:lxpbi .38s cubic-bezier(.22,1,.36,1);overflow:hidden; }
.lx-tnc-header { display:flex;align-items:center;justify-content:space-between;padding:20px 28px 16px;border-bottom:1px solid rgba(45,57,145,.08);position:relative; }
.lx-tnc-header::after { content:'';position:absolute;bottom:0;left:0;right:0;height:3px;background:linear-gradient(90deg,var(--lx-sky),var(--lx-mid),var(--lx-navy),var(--lx-mid),var(--lx-sky));background-size:200% 100%;animation:lxtb 2.8s linear infinite; }
.lx-tnc-title { font-family:var(--lx-fd);font-size:1.1rem;font-weight:700;color:var(--lx-text); }
.lx-tnc-close { background:rgba(45,57,145,.07);border:none;cursor:pointer;width:32px;height:32px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:.85rem;color:var(--lx-muted);transition:background .2s,color .2s; }
.lx-tnc-close:hover { background:rgba(232,57,90,.1);color:var(--lx-error); }
.lx-tnc-body { overflow-y:auto;padding:24px 28px;font-family:var(--lx-fb);font-size:.88rem;color:var(--lx-muted);line-height:1.75;display:flex;flex-direction:column;gap:14px;flex:1; }
.lx-tnc-body p strong { color:var(--lx-navy); }
.lx-tnc-body ol { padding-left:20px;display:flex;flex-direction:column;gap:10px; }
.lx-tnc-body ol li { color:var(--lx-text); }
.lx-tnc-withdraw { font-size:.82rem;color:var(--lx-muted);padding:10px 14px;background:rgba(50,85,204,.05);border-left:3px solid var(--lx-mid);border-radius:0 8px 8px 0; }
.lx-tnc-footer { padding:16px 28px 20px;border-top:1px solid rgba(45,57,145,.08); }
.lx-tnc-btn { width:100%;padding:12px;border:none;border-radius:13px;cursor:pointer;font-family:var(--lx-fd);font-size:.95rem;font-weight:700;color:white;background:linear-gradient(120deg,var(--lx-navy) 0%,var(--lx-mid) 55%,#4B70EE 100%);box-shadow:0 4px 18px rgba(50,85,204,.38);transition:transform .18s,box-shadow .18s; }
.lx-tnc-btn:hover { transform:translateY(-2px);box-shadow:0 8px 24px rgba(50,85,204,.46); }

/* ── fn note ── */
.lx-fn { margin-top:12px;text-align:center;font-size:.72rem;color:var(--lx-muted);line-height:1.65;opacity:.8;font-family:var(--lx-fb); }

/* ── Responsive ── */
@media(max-width:920px){
  .lx-wrap { grid-template-columns:1fr; }
  .lx-left { padding:36px 24px 24px;align-items:center;text-align:center; }
  .lx-date-pill { justify-content:center; }
  .lx-rings,.lx-deco { display:none; }
  .lx-right { padding:16px 18px 44px; }
}
@media(max-width:480px){
  .lx-logo { height:110px; }
  .lx-card { padding:26px 18px 20px; }
}
`

// ─── Main component ───────────────────────────────────────────────────────────
const Login = props => {
  const [modalState, setModalState] = useState(false)
  const [activeTab, setActiveTab] = useState("Individual")
  const [activeTabContent, setActiveTabContent] = useState("1")
  const [showPassword, setShowPassword] = useState(false)
  const [alertVisible, setAlertVisible] = useState(true)
  const [messageToken, setMessageToken] = useState("")
  const [helprc, onhelpOpenRC] = useState(false)
  const [toggleMessage, setToggleMessage] = useState("")
  const [consent, setConsent] = useState(false)
  const [authMode, setAuthMode] = useState(null)
  const formRef = useRef(null)
  var tawklink = ""

  const [regState, setRegState] = useState("")
  const [regCity, setRegCity] = useState("")
  const [regOtherCity, setRegOtherCity] = useState("")
  const [themedPopup, setThemedPopup] = useState(null)
  const [tncOpen, setTncOpen] = useState(false)

  const regCities = regState ? STATE_CITIES[regState] || [] : []

  useEffect(() => {
    setRegCity("")
    setRegOtherCity("")
  }, [regState])

  useEffect(() => {
    const loader = document.querySelector(".loader")
    loader.classList.add("loader--hide")
    setMessageToken(localStorage.getItem("notificationToken"))
  }, [])

  const toggle1 = tab => {
    if (activeTab !== tab) setActiveTab(tab)
  }
  const Alldata = JSON.parse(localStorage.getItem("dataJ"))
  const toggleModal = () => setModalState(!modalState)
  const togglePasswordVisibility = () => setShowPassword(!showPassword)
  const hideAlert = () => setAlertVisible(false)

  const [popup, setPopup] = useState({ isOpen: false, type: "", message: "" })
  const closePopup = () => setPopup({ isOpen: false, type: "", message: "" })

  const [regLoading, setRegLoading] = useState(false)
  const [loginLoading, setLoginLoading] = useState(false)

  const handleRegisterSubmit = async (event, values) => {
    console.log("Register submitted:", values)
    setRegLoading(true)
    try {
      const res = await fetch(process.env.REACT_APP_ADMIN + "/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          Firstname: values.Firstname,
          Lastname: "",
          Email: values.Email,
          State: values.State,
          City:
            values.OtherCity && values.City === "Other"
              ? values.OtherCity
              : values.City,
          PhoneNumber: values.PhoneNumber,
          customaction: "Register",
          Token: messageToken,
        }),
      })
      const data = await res.json()
      console.log("Register response:", data)
      const mssg = data?.mssg || ""

      if (data?.document) {
        setThemedPopup({
          type: "success",
          title: "Thank you for Registering! 🎉",
          message: mssg || "We look forward to seeing you!",
          dateNote: "27th March · 7:00 PM Onwards",
        })
        setRegState("")
        setRegCity("")
        setRegOtherCity("")
        setConsent(false)
        setAuthMode(null)
      } else if (mssg.toLowerCase().includes("already")) {
        setThemedPopup({
          type: "success",
          title: "Already Registered!",
          message: mssg,
          dateNote: "27th March · 7:00 PM Onwards",
        })
      } else {
        setThemedPopup({
          type: "error",
          title: "Registration Failed",
          message: mssg || "Something went wrong. Please try again.",
          dateNote: null,
        })
      }
    } catch (err) {
      console.error("Register fetch error:", err)
      setThemedPopup({
        type: "error",
        title: "Network Error",
        message: "Could not reach the server. Please check your connection.",
        dateNote: null,
      })
    } finally {
      setRegLoading(false)
    }
  }

  const handleValidSubmit = async (event, values) => {
  const isLogin = values.customaction === "Login"
  isLogin ? setLoginLoading(true) : setRegLoading(true)

  try {
    const res = await fetch(process.env.REACT_APP_ADMIN + "/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        Firstname: values.Firstname,
        Lastname: "",
        Email: values.Email,
        State: values.State || "",
        City:
          values.OtherCity && values.City === "Other"
            ? values.OtherCity
            : values.City || "",
        PhoneNumber: values.PhoneNumber || "",
        customaction: values.customaction,
        Token: messageToken,
      }),
    })
    const data = await res.json()
    const mssg = data?.mssg || ""

    if (!isLogin) {
      // ── REGISTER: if success, auto-login immediately ──
      if (data?.document) {
        const loginRes = await fetch(process.env.REACT_APP_ADMIN + "/login", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            Firstname: values.Firstname,
            Email: values.Email,
            customaction: "Login",
            Token: messageToken,
          }),
        })
        const loginData = await loginRes.json()
        if (loginData?.document?.Email) {
          localStorage.setItem("authUser", JSON.stringify(loginData.document))
          setThemedPopup({
            type: "success",
            title: "Registered & Logged In! 🎉",
            message: "Welcome! Redirecting you now...",
          })
          setTimeout(() => props.history.push("/page/lobby"), 1200)
        } else {
          setThemedPopup({
            type: "error",
            title: "Auto-login Failed",
            message: "Registered, but login failed. Please login manually.",
          })
          setAuthMode("login")
        }
      } else if (mssg.toLowerCase().includes("already registered")) {
        setThemedPopup({
          type: "error",
          title: "Already Registered",
          message: "You are already registered. Please login.",
        })
        setAuthMode("login")
      } else {
        setThemedPopup({
          type: "error",
          title: "Registration Failed",
          message: mssg || "Something went wrong. Please try again.",
        })
      }
      return
    }

    // ── LOGIN ──
    if (data?.document?.Email) {
      localStorage.setItem("authUser", JSON.stringify(data.document))
      setThemedPopup({
        type: "success",
        title: "Welcome!",
        message: mssg || "Login successful. Redirecting you now...",
      })
      setTimeout(() => props.history.push("/page/lobby"), 1200)
    } else if (mssg.toLowerCase().includes("not found")) {
      setThemedPopup({
        type: "error",
        title: "User Not Found",
        message: mssg,
      })
    } else {
      setThemedPopup({
        type: "error",
        title: "Login Failed",
        message: mssg || "Something went wrong. Please try again.",
      })
    }
  } catch (err) {
    console.error("Submit error:", err)
    setThemedPopup({
      type: "error",
      title: "Network Error",
      message: "Could not reach the server. Please check your connection.",
    })
  } finally {
    isLogin ? setLoginLoading(false) : setRegLoading(false)
  }
}

  const handleTabToggle = tab => {
    if (activeTab !== tab) setActiveTab(tab)
  }
  const handleToggleMessage = event => setToggleMessage(event.target.value)

  const renderAlert = () => {
    if (props.error && typeof props.error === "string") {
      let alertTitle = ""
      let alertType = "warning"
      console.log("props : ", props)
      if (
        props.error ===
          "Your ID has been registered. Please come back again on the event day to log in." ||
        props.error ===
          "User Already registered , Please come back again on the event day to log in." ||
        props.error === "Somethiing went wrong, Please try again!"
      ) {
        alertTitle = props.error.includes("already registered")
          ? "Already Registered"
          : "Registered Successfully"
        alertType = "success"
      }
      return (
        <SweetAlert
          style={{ color: "#000" }}
          show={alertVisible}
          type={alertType}
          title={alertTitle}
          onConfirm={hideAlert}
        >
          {props?.error}
        </SweetAlert>
      )
    }
    return null
  }

  let Imguser =
    "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/Iron%20Biotics%20Summit%2FSpeaker%20Image%20with%20text.png?alt=media&token=e197a0f7-f1ac-4130-8e75-0e4d57e1690c"
  let logoText =
    "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/Iron%20Biotics%20Summit%2FLogo.png?alt=media&token=b60eb503-cb1a-48d0-8688-b3686fbae80b"

  return (
    <React.Fragment>
      <MetaTags>
        <title>Mindex Clinical Spectrum 2026</title>
      </MetaTags>

      <style>{css}</style>

      {/* Background — static Firebase image (blobs/grid/grain/particles commented out) */}
      <div className="lx-scene">
        {/*
        <div className="lx-grid" />
        <div className="lx-blob lx-b1" /><div className="lx-blob lx-b2" />
        <div className="lx-blob lx-b3" /><div className="lx-blob lx-b4" />
        <Particles />
        <div className="lx-grain" />
        */}
      </div>

      {tncOpen && <TnCModal onClose={() => setTncOpen(false)} />}
      {themedPopup && (
        <ThemedPopup {...themedPopup} onClose={() => setThemedPopup(null)} />
      )}

      {/* Original modals — preserved exactly */}
      <Modal
        size="xl"
        isOpen={modalState}
        toggle={toggleModal}
        centered
        style={{ width: "auto" }}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0">Photo Mosaic</h5>
          <button
            type="button"
            onClick={toggleModal}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <iframe
            allow="camera; microphone"
            title="test"
            className="embed-responsive-item mosaic"
            src={encodeURI("https://demo-mosaic.herokuapp.com/")}
          />
        </div>
      </Modal>

      <Modal
        isOpen={helprc}
        toggle={() => {
          onhelpOpenRC(!helprc)
        }}
        centered={true}
        style={{ width: "auto" }}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0">Help Desk</h5>
          <button
            type="button"
            onClick={() => {
              onhelpOpenRC(!helprc)
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          {Alldata.data.lobby.data.areas.map((item, i) =>
            (() => {
              switch (item.id) {
                case "help": {
                  ;<div>
                    {item.url ? (tawklink = item.url) : (tawklink = "")}
                  </div>
                }
              }
            })()
          )}
          <iframe
            height="450px"
            width="100%"
            title="test"
            className="embed-responsive-item"
            src={encodeURI(tawklink)}
          />
        </div>
      </Modal>

      {/* Main layout */}
      <div className="lx-wrap">
        {/* LEFT — logo + date */}
        <div className="lx-left">
          <div className="lx-deco" aria-hidden="true">
            <img src={Logo} alt="" />
          </div>
          <div className="lx-rings">
            <div className="lx-ring lx-r1" />
            <div className="lx-ring lx-r2" />
            <div className="lx-ring lx-r3" />
            <div className="lx-ring lx-r4" />
            <div className="lx-ring lx-r5" />
          </div>
          <div className="lx-a1">
            <img
              className="lx-logo"
              src={NameLogo}
              alt="Mindex Clinical Spectrum"
            />
          </div>
          <div className="lx-a2">
            <div className="lx-date-pill">
              <span className="lx-dot" />
              <span className="lx-date-text">
                27th March &nbsp;·&nbsp; 7PM Onwards
              </span>
            </div>
          </div>
        </div>

        {/* RIGHT — form card */}
        <div className="lx-right">
          <div className="lx-card">
            <div className="lx-ct">Mindex Clinical Spectrum</div>
            <div className="lx-cs">Welcome — login or register below</div>

            {!authMode && (
              <div>
                <button
                  className="lx-auth-btn"
                  onClick={() => setAuthMode("login")}
                >
                  Login <span className="lx-arr">→</span>
                </button>
                <div className="lx-divider">or</div>
                <button
                  className="lx-auth-btn-outline"
                  onClick={() => setAuthMode("register")}
                >
                  Register
                </button>
              </div>
            )}

            {authMode === "login" && (
              <AvForm
                ref={formRef}
                className="form-horizontal"
                onValidSubmit={handleValidSubmit}
              >
                <button
                  type="button"
                  className="lx-back"
                  onClick={() => setAuthMode(null)}
                >
                  ← Back
                </button>
                <div className="lx-section-title">Login</div>
                <div className="mb-1">
                  <AvField
                    name="Firstname"
                    className="form-control"
                    placeholder="Full Name *"
                    type="text"
                    required
                  />
                </div>
                <div className="mb-1">
                  <AvField
                    name="Email"
                    className="form-control"
                    placeholder="Email ID *"
                    type="email"
                    required
                  />
                </div>
                <div className="mb-3">
                  <AvField
                    name="Token"
                    value={messageToken}
                    className="form-control"
                    placeholder="token"
                    type="text"
                    hidden
                  />
                </div>
                <div className="mb-3">
                  <AvField
                    name="customaction"
                    value="Login"
                    className="form-control"
                    placeholder="action *"
                    type="text"
                    required
                    disabled
                    hidden
                  />
                </div>
                <button
                  className="lx-sbtn"
                  type="submit"
                  disabled={loginLoading}
                >
                  {loginLoading ? (
                    <span>
                      Logging in
                      <span className="lx-spin" />
                    </span>
                  ) : (
                    <span>
                      Login <span className="lx-arr">→</span>
                    </span>
                  )}
                </button>
              </AvForm>
            )}

            {authMode === "register" && (
              <AvForm
                ref={formRef}
                className="form-horizontal"
                onValidSubmit={handleValidSubmit}
              >
                <button
                  type="button"
                  className="lx-back"
                  onClick={() => {
                    setAuthMode(null)
                    setConsent(false)
                  }}
                >
                  ← Back
                </button>
                <div className="lx-section-title">Register</div>

                <div className="lx-fg mb-1">
                  <label className="lx-fl">Full Name</label>
                  <AvField
                    name="Firstname"
                    className="form-control"
                    placeholder="Enter your full name *"
                    type="text"
                    required
                    errorMessage="Full name is required"
                  />
                </div>
                <div className="lx-fg mb-1">
                  <label className="lx-fl">Email ID</label>
                  <AvField
                    name="Email"
                    className="form-control"
                    placeholder="Email Id *"
                    type="email"
                    required
                    errorMessage="Please enter a valid email"
                  />
                </div>
                <div className="lx-fg mb-1">
                  <label className="lx-fl">State</label>
                  <div className="lx-sel">
                    <AvField
                      name="State"
                      type="select"
                      className="form-control"
                      required
                      errorMessage="Please select a state"
                      value={regState}
                      onChange={e => setRegState(e.target.value)}
                    >
                      <option value="">Select a state *</option>
                      {Object.keys(STATE_CITIES)
                        .sort()
                        .map(s => (
                          <option key={s} value={s}>
                            {s}
                          </option>
                        ))}
                    </AvField>
                  </div>
                </div>
                <div className="lx-fg mb-1">
                  <label className="lx-fl">City</label>
                  <div className="lx-sel">
                    <AvField
                      name="City"
                      type="select"
                      className="form-control"
                      required
                      errorMessage="Please select a city"
                      value={regCity}
                      onChange={e => setRegCity(e.target.value)}
                      disabled={!regState}
                    >
                      <option value="">Select a city *</option>
                      {regCities.map(c => (
                        <option key={c} value={c}>
                          {c}
                        </option>
                      ))}
                      {regState && <option value="Other">Other</option>}
                    </AvField>
                  </div>
                  <div
                    className={`lx-other-city${
                      regCity === "Other" ? " visible" : ""
                    }`}
                  >
                    <AvField
                      name="OtherCity"
                      className="form-control"
                      placeholder="Please specify your city *"
                      type="text"
                      value={regOtherCity}
                      onChange={e => setRegOtherCity(e.target.value)}
                      validate={
                        regCity === "Other"
                          ? {
                              required: {
                                value: true,
                                errorMessage: "Please specify your city",
                              },
                            }
                          : {}
                      }
                    />
                  </div>
                </div>
                <div className="lx-fg mb-1">
                  <label className="lx-fl">Contact Number</label>
                  <div className="lx-phone-row">
                    <div className="lx-phone-pre">+91</div>
                    <AvField
                      name="PhoneNumber"
                      className="form-control"
                      placeholder="10-digit number *"
                      type="text" 
                      validate={{
                        required: {
                          value: true,
                          errorMessage: "Phone number is required",
                        },
                        pattern: {
                          value: "^[0-9]{10}$",
                          errorMessage: "Enter a valid 10-digit number",
                        },
                      }}
                      maxLength={10}
                      onChange={e =>
                        (e.target.value = e.target.value
                          .replace(/\D/g, "")
                          .slice(0, 10))
                      }
                    />
                  </div>
                </div>

                <AvField name="Lastname" value="" type="text" hidden />
                <AvField name="Token" value={messageToken} type="text" hidden />
                <AvField
                  name="customaction"
                  value="Register"
                  type="text"
                  disabled
                  hidden
                />

                <div className={`lx-tnc-row${consent ? " checked" : ""}`}>
                  <label className="lx-tnc-chk">
                    <input
                      type="checkbox"
                      checked={consent}
                      onChange={e => setConsent(e.target.checked)}
                    />
                    <span className="lx-tnc-box">
                      <svg width="10" height="8" viewBox="0 0 10 8" fill="none">
                        <path
                          d="M1 4L3.5 6.5L9 1"
                          stroke="white"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                  </label>
                  <span className="lx-tnc-lbl">
                    I agree to the{" "}
                    <button
                      type="button"
                      className="lx-tnc-link"
                      onClick={() => setTncOpen(true)}
                    >
                      Terms &amp; Conditions
                    </button>
                  </span>
                </div>

                <button
                  className="lx-sbtn"
                  type="submit"
                  disabled={!consent || regLoading}
                >
                  {regLoading ? (
                    <span>
                      Registering
                      <span className="lx-spin" />
                    </span>
                  ) : (
                    <span>
                      Submit <span className="lx-arr">→</span>
                    </span>
                  )}
                </button>
                <p className="lx-fn">
                  * Please use your official ID to register
                </p>
              </AvForm>
            )}
          </div>
        </div>
      </div>

      {/* Original CustomPopup — preserved */}
      <CustomPopup
        isOpen={popup.isOpen}
        onClose={closePopup}
        type={popup.type}
        message={popup.message}
      />

      {/* Original help button — preserved */}
      <div
        style={{
          cursor: "pointer",
          height: "80px",
          width: "80px",
          position: "absolute",
          top: "85%",
          right: "10%",
          display: "none",
        }}
      >
        <img
          width="100px"
          src="https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/apple%20virtual%20platform%2FHELP%20Button.png?alt=media"
          onClick={() => {
            onhelpOpenRC(!helprc)
          }}
        />
      </div>

      {/* Original TabContent (tabId 2 & 3) — preserved exactly, hidden */}
      <div style={{ display: "none" }}>
        <TabContent activeTab="none">
          <TabPane tabId="3">
            <AvForm
              className="form-horizontal"
              onValidSubmit={handleValidSubmit}
            >
              <div className="mb-1">
                <AvField
                  name="Firstname"
                  className="form-control"
                  placeholder="Name *"
                  type="text"
                  required
                />
              </div>
              <div className="mb-1">
                <AvField
                  name="Email"
                  className="form-control"
                  placeholder="Email ID*"
                  type="email"
                  required
                />
              </div>
              <div className="mb-1">
                <AvField
                  name="Company"
                  className="form-control"
                  placeholder="Organisation *"
                  type="text"
                  required
                />
              </div>
              <div className="mb-3 applebtn">
                <AvField
                  name="customaction"
                  value="Login"
                  className="form-control newgrad"
                  placeholder="action *"
                  type="text"
                  required
                  disabled
                  hidden
                />
              </div>
            </AvForm>
          </TabPane>
          <TabPane tabId="2">
            <AvForm
              className="form-horizontal"
              onValidSubmit={handleValidSubmit}
            >
              <div className="mb-1">
                <AvField
                  name="Firstname"
                  className="form-control"
                  placeholder="Full Name *"
                  type="text"
                  required
                />
              </div>
              <div className="mb-1">
                <AvField
                  name="EmployerName"
                  className="form-control"
                  placeholder="Employer Name *"
                  type="text"
                  required
                />
              </div>
              <div className="mb-1">
                <AvField
                  name="Email"
                  className="form-control"
                  placeholder="Email ID *"
                  type="email"
                  required
                />
              </div>
              <div className="mb-1">
                <AvField
                  name="storeName"
                  className="form-control"
                  placeholder="Store Name *"
                  type="text"
                  required
                />
              </div>
              <div className="mb-3">
                <AvField
                  name="customaction"
                  value="Register"
                  className="form-control newgrad"
                  placeholder="action *"
                  type="text"
                  required
                  disabled
                  hidden
                />
              </div>
            </AvForm>
          </TabPane>
        </TabContent>
      </div>
    </React.Fragment>
  )
}

Login.propTypes = {
  error: PropTypes.any,
  history: PropTypes.object,
  loginUser: PropTypes.func,
  socialLogin: PropTypes.func,
}

const mapStateToProps = state => {
  const { error } = state.Login
  return { error }
}

export default withRouter(
  connect(mapStateToProps, { loginUser, apiError, socialLogin })(Login)
)
